import React, { createContext, useContext, useState } from 'react';

const QuestionnaireContext = createContext();

export const QuestionnaireProvider = ({ children }) => {
  const [questionnaires, setQuestionnaires] = useState([]);

  const setNewQuestionnaires = (data) => {
    setQuestionnaires(data);
  };

  return (
    <QuestionnaireContext.Provider value={{ questionnaires, setNewQuestionnaires }}>
      {children}
    </QuestionnaireContext.Provider>
  );
};

export const useQuestionnaireContext = () => useContext(QuestionnaireContext);
